import { Injectable } from '@angular/core';
import { Chat } from '../interfaces/zeyo-ia';

@Injectable({
	providedIn: 'root'
})
export class ChatsIaService {
	loadings = {
		search: false
	};

	analyticsChat: Chat[] = [
		{
			message: 'Hola, en qué puedo ayudarte?',
			how: 'ia',
			configurations: {
				message: '',
				loading: 'success'
			},
			answer: '',
			showOptions: false,
			creationTime: undefined,
			status: 'completed'
		}
	];

	processChat: Chat[] = [
		{
			message: 'Hola, en qué puedo ayudarte?',
			how: 'ia',
			configurations: {
				message: '',
				loading: 'success'
			},
			answer: '',
			showOptions: false,
			creationTime: undefined,
			status: 'completed'
		}
	];

	resetChats(): void {
		this.analyticsChat = [
			{
				message: 'Hola, en qué puedo ayudarte?',
				how: 'ia',
				configurations: {
					message: '',
					loading: 'success'
				},
				answer: '',
				showOptions: false,
				creationTime: undefined,
				status: 'completed'
			}
		];

		this.processChat = [
			{
				message: 'Hola, en qué puedo ayudarte?',
				how: 'ia',
				configurations: {
					message: '',
					loading: 'success'
				},
				answer: '',
				showOptions: false,
				creationTime: undefined,
				status: 'completed'
			}
		];
	}
}
